import { basename } from 'path';
import { emit } from '@nextcloud/event-bus';
import { getCurrentUser } from '@nextcloud/auth';
import { Permission, Folder } from '@nextcloud/files';
import { showError, showSuccess } from '@nextcloud/dialogs';
import { translate as t } from '@nextcloud/l10n';
import axios from '@nextcloud/axios';
import FolderPlusSvg from '@mdi/svg/svg/folder-plus-outline.svg?raw';
import { newNodeName } from '../utils/newNodeDialog';
import logger from '../logger';
const createNewFolder = async (root, name) => {
    const source = root.source + '/' + name;
    const encodedSource = root.encodedSource + '/' + encodeURIComponent(name);
    const response = await axios({
        method: 'MKCOL',
        url: encodedSource,
        headers: {
            Overwrite: 'F',
        },
    });
    return {
        fileid: parseInt(response.headers['oc-fileid']),
        source,
    };
};
export const entry = {
    id: 'newFolder',
    displayName: t('files', 'New folder'),
    enabled: (context) => Boolean(context.permissions & Permission.CREATE) && Boolean(context.permissions & Permission.READ),
    // Make the svg icon color match the primary element color
    iconSvgInline: FolderPlusSvg.replace(/viewBox/gi, 'style="color: var(--color-primary-element)" viewBox'),
    order: 0,
    async handler(context, content) {
        const name = await newNodeName(t('files', 'New folder'), content, { isFolder: true });
        if (name === null) {
            return;
        }
        try {
            const { fileid, source } = await createNewFolder(context, name.trim());
            // Create the folder in the store
            const folder = new Folder({
                source,
                id: fileid,
                mtime: new Date(),
                owner: context.owner,
                permissions: Permission.ALL,
                root: context?.root || '/files/' + getCurrentUser()?.uid,
                // Include mount-type from parent folder as this is inherited
                attributes: {
                    'mount-type': context.attributes?.['mount-type'],
                    'owner-id': context.attributes?.['owner-id'],
                    'owner-display-name': context.attributes?.['owner-display-name'],
                    'hide-download': context.attributes?.['hide-download'],
                },
            });
            // Show success
            emit('files:node:created', folder);
            showSuccess(t('files', 'Created new folder "{name}"', { name: basename(source) }));
            logger.debug('Created new folder', { folder, source });
            // Navigate to the new folder
            window.OCP.Files.Router.goToRoute(null, // use default route
            { view: 'files', fileid: String(fileid) }, { dir: context.path });
        }
        catch (error) {
            logger.error('Creating new folder failed', { error });
            showError('Creating new folder failed');
        }
    },
};
